module.exports = __webpack_public_path__ + "c6d34abe5f2c995d3ab2feb63b7b0834.svg";